export default __webpack_public_path__ + "static/media/04.e6f188ae.jpg";